// extracted by mini-css-extract-plugin
export default {"provider":"ContentReferenceTab__provider__PC_3_","tabPanel":"ContentReferenceTab__tabPanel__jV57f"};